<template>
  <div class="form-group" :class="{ 'has-error': error }" :style="'width:' + width + 'px'">
    <label class="text-info" v-if="label" :for="name">{{ label }}</label>
    <input v-if="mask != ''" type="text" class="form-control" :class="classes" :style="'width:' + width + 'px'"
           :value="value"
           v-mask="mask"
           @input="updateValue($event.target.value)"
           @blur="updateValue($event.target.value)"
           @keypress.enter="$emit('enter')"
           :name="name"
           :required="required"
           :disabled="disabled"
           :placeholder="placeholder"
           :readonly="readonly"
           autocomplete="on"
    >
    <input v-else="" type="text" class="form-control" :class="classes" :style="'width:' + width + 'px'"
           :value="value"
           @input="updateValue($event.target.value)"
           @blur="updateValue($event.target.value)"
           @keypress.enter="$emit('enter')"
           :name="name"
           :required="required"
           :disabled="disabled"
           :placeholder="placeholder"
           :readonly="readonly"
           autocomplete="on"
    >
    <span v-if="error" class="help-block" v-html="error"></span>
  </div>
</template>

<script>
  export default{
    name: 'InputText',
    props: {
      classes: {
        type: String,
        default: ''
      },
      width: {
        type: String,
        default: ''
      },
      name: {
        type: String,
        default: ''
      },
      value: {
        type: String,
        default: ''
      },
      required: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      error: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      readonly: {
        type: Boolean,
        default: false
      },
      mask: {
        type: String,
        default: ''
      }
    },
    methods: {
      updateValue (value) {
        this.$emit('input', value)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// InputText.vue?27853256